import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import type { BaseError } from '@utils/types/shared/base.ts';
import type {
  PublishJob,
  PublishJobResponse,
  StartPublishJobPayload
} from '@utils/types/publishing/publish.ts';

interface Args {
  sessionId: string;
  documentId: string;
  payload: StartPublishJobPayload;
}

async function startPublishJob({
  sessionId,
  documentId,
  payload
}: Args): Promise<PublishJob> {
  const { data } = await Axios.post<PublishJobResponse>(
    POST_URL(sessionId, documentId).startPublishJob,
    payload
  );
  return data.result;
}

export function useStartPublishJob() {
  const queryClient = useQueryClient();

  return useMutation<PublishJob, AxiosError<BaseError>, Args>(startPublishJob, {
    onSuccess: (_job, variables) => {
      queryClient.invalidateQueries(
        QueryKeys.documentPublishHistory(
          variables.sessionId,
          variables.documentId
        )
      );
    },
    useErrorBoundary: false
  });
}
